export default __webpack_public_path__ + "static/media/login_button.25e9fef7.svg";